import React, {useEffect, useState} from 'react';
import { Route, Switch } from 'react-router';
import Sidebar from './sidebar/Sidebar';
import Topbar from './topbar/Topbar';
import { ROUTES_LIST } from '../helpers/routesList';
import { ArchiveList } from './pages/Archive/ArchiveList';
import { CmsUserList } from './pages/CmsUser/CmsUserList/CmsUserList';
import { CmsUserCreate } from './pages/CmsUser/CmsUserCreate/CmsUserCreate';
import { CmsUserEdit } from './pages/CmsUser/CmsUserEdit/CmsUserEdit';
import { ChannelList } from './pages/Channel/ChannelList/ChannelList';
import { ChannelCreate } from './pages/Channel/ChannelCreate/ChannelCreate';
import { ChannelEdit } from './pages/Channel/ChannelEdit/ChannelEdit';
import { ProgramTypeList } from './pages/ProgramType/ProgramTypeList/ProgramTypeList';
import { ProgramTypeCreate } from './pages/ProgramType/ProgramTypeCreate/ProgramTypeCreate';
import { ProgramTypeEdit } from './pages/ProgramType/ProgramTypeEdit/ProgramTypeEdit';
import { ProgramsList } from './pages/Program/ProgramList/ProgramsList';
import { ProgramCreate } from './pages/Program/ProgramCreate/ProgramCreate';
import { ProgramDetailCreate } from './pages/ProgramDetail/ProgramDetailCreate/ProgramDetailCreate';
import { ProgramFileList } from './pages/ProgramFile/ProgramFileList/ProgramFileList';
import { ProgramFileForm } from './pages/ProgramFile/ProgramFileForm';
import { ProgramDetailEdit } from './pages/ProgramDetail/ProgramDetailEdit/ProgramDetailEdit';
import { Epg } from './pages/Epg/Epg';
import EpgDetail from './pages/Epg/EpgDetail';
import ArchiveGraph from './pages/Archive/ArchiveGraph';
import { ChannelTypeList } from './pages/ChannelType/ChannelTypeList/ChannelTypeList';
import { ChannelTypeCreate } from './pages/ChannelType/ChannelTypeCreate/ChannelTypeCreate';
import { ChannelTypeEdit } from './pages/ChannelType/ChannelTypeEdit/ChannelTypeEdit';
import {Execute} from "./pages/Execute/Execute";
import { EpgProcess } from './pages/EpgProcess/EpgProcess';
import { ForeignChannel } from './pages/ForeignChannel/ForeignChannel';
import { Example } from './pages/Example/Example';
import { EpgPoster } from './pages/EpgPoster/EpgPoster';

export default function Dashboard() {
    const [showSidebar, setShowSidebar] = useState(true);

    return (
        <>
            <Topbar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
            <div className="container">
                <div className={`sidebar ${showSidebar ? 'showSidebar' : ''}`}>
                    <Sidebar showSidebar={showSidebar} />
                </div>
                <div className="pages">
                    <Switch>
                        {/*
                            CmsUser
                        */}
                        <Route path={ROUTES_LIST.cmsUserCreate}>
                            <CmsUserCreate />
                        </Route>
                        <Route path={ROUTES_LIST.cmsUserEdit}>
                            <CmsUserEdit />
                        </Route>

                        <Route path={ROUTES_LIST.cmsUserList}>
                            <CmsUserList />
                        </Route>

                        {/* 
                            Channel
                        */}

                        <Route exact path={ROUTES_LIST.channelCreate}>
                            <ChannelCreate />
                        </Route>
                        <Route path={ROUTES_LIST.channelEdit}>
                            <ChannelEdit />
                        </Route>
                        <Route path={ROUTES_LIST.channelList}>
                            <ChannelList />
                        </Route>
                        <Route path={ROUTES_LIST.foreignChannelList}>
                            {/*Foreign channel*/}
                            <ForeignChannel />
                        </Route>
                        <Route exact path={ROUTES_LIST.epgProcess}>
                            <EpgProcess/>
                        </Route>

                        {/* {channelTypeList} */}
                        //--------------------------------------------------
                        
                          <Route exact path={ROUTES_LIST.channelTypeList}>
                            <ChannelTypeList />
                        </Route>
                        <Route exact path={ROUTES_LIST.channelTypeCreate}>
                            <ChannelTypeCreate />
                        </Route>
                        <Route path={ROUTES_LIST.channelTypeEdit}>
                            <ChannelTypeEdit />
                        </Route>
                         <Route exact path={ROUTES_LIST.execute}>
                            <Execute/>
                        </Route>
//-------------------------------------------------
                        {/* 
                            ProgramType
                        */}
                        <Route exact path={ROUTES_LIST.programTypeCreate}>
                            <ProgramTypeCreate />
                        </Route>
                        <Route path={ROUTES_LIST.programTypeEdit}>
                            <ProgramTypeEdit />
                        </Route>
                        <Route exact path={ROUTES_LIST.programTypeList}>
                            <ProgramTypeList />
                        </Route>

                        {/* 
                            Program weekly list
                         */}

                        <Route exact path={ROUTES_LIST.programCreate}>
                            <ProgramCreate />
                        </Route>
                        <Route exact path={ROUTES_LIST.programList}>
                            <ProgramsList />
                        </Route>

                        {/* 
                            ProgramFile
                        */}
                        <Route exact path={ROUTES_LIST.programFileUpload}>
                            <ProgramFileForm />
                        </Route>
                        <Route exact path={ROUTES_LIST.programFileList}>
                            <ProgramFileList />
                        </Route>

                        {/* 
                            Archive
                        */}

                        <Route exact path={ROUTES_LIST.programArchive}>
                            <ArchiveList />
                        </Route>
                        <Route exact path={ROUTES_LIST.programArchiveGraph}>
                            <ArchiveGraph />
                        </Route>

                        {/* 
                            Program detail
                        */}

                        <Route exact path={ROUTES_LIST.programDetailCreate}>
                            <ProgramDetailCreate />
                        </Route>
                        <Route exact path={ROUTES_LIST.programDetailEdit}>
                            <ProgramDetailEdit />
                        </Route>

                        {/* 
                            EPG 
                        */}
                        <Route exact path={ROUTES_LIST.epgPosters}>
                            <EpgPoster />
                        </Route>
                        <Route exact path={ROUTES_LIST.epgPage}>
                            <Epg />
                        </Route>
                        <Route exact path={ROUTES_LIST.epgPageDetail}>
                            <EpgDetail />
                        </Route>

                        <Route exact path={ROUTES_LIST.downloadExample}>
                            <Example />
                        </Route>
                    </Switch>
                </div>
            </div>
        </>
    );
}
